import type { CSSProperties } from "react";
import { motion as motionTokens } from "@tokens/index";

/**
 * Style for a surface that still shows the previous result while the next one
 * loads (TanStack `placeholderData: keepPreviousData`). The content stays in
 * place and dims instead of unmounting into a skeleton, so a selection change
 * reads as "updating", not "gone".
 */
export function staleDataStyle(isStale: boolean): CSSProperties {
    return {
        opacity: isStale ? 0.6 : 1,
        transition: `opacity ${motionTokens.durations.fast} ${motionTokens.easings.standard}`,
    };
}
